import { render, staticRenderFns } from "./orderCounts.vue?vue&type=template&id=8f50da5a&scoped=true&"
import script from "./orderCounts.vue?vue&type=script&lang=js&"
export * from "./orderCounts.vue?vue&type=script&lang=js&"
import style0 from "./orderCounts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./orderCounts.vue?vue&type=style&index=1&id=8f50da5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50da5a",
  null
  
)

component.options.__file = "orderCounts.vue"
export default component.exports